var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile-dropdown flex-center" },
    [
      _c(
        "span",
        { staticClass: "profile-dropdown__avatar-container" },
        [_vm._t("default")],
        2
      ),
      _c(
        "vuestic-dropdown",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShown,
            callback: function ($$v) {
              _vm.isShown = $$v
            },
            expression: "isShown",
          },
        },
        _vm._l(_vm.options, function (option) {
          return _c(
            "a",
            {
              key: option.name,
              staticClass: "dropdown-item plain-link-item",
              on: {
                click: function ($event) {
                  return _vm.show(option.name)
                },
              },
            },
            [
              _c("span", { staticClass: "dropdown-item__text ellipsis" }, [
                _vm._v(_vm._s(_vm.$t(`user.${option.name}`))),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }